
import { defineComponent, PropType } from 'vue'
import { iScorecard } from '../KpiDocumentDesigner'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import KpiDocumentDesignerScorecardsListCardDescriptor from './KpiDocumentDesignerScorecardsListCardDescriptor.json'
import KpiDocumentDesignerScorecardSelectDialog from './KpiDocumentDesignerScorecardSelectDialog.vue'

export default defineComponent({
    name: 'kpi-edit-scorecards-list-card',
    components: { Card, Column, DataTable, KpiDocumentDesignerScorecardSelectDialog },
    props: { propData: { type: Object }, scorecardList: { type: Array as PropType<iScorecard[]> } },
    emits: ['scorecardChanged'],
    data() {
        return {
            KpiDocumentDesignerScorecardsListCardDescriptor,
            scorecards: [] as iScorecard[],
            filters: { global: [filterDefault] } as Object,
            addScorecardVisible: false
        }
    },
    watch: {
        propData() {
            this.loadScorecard()
        }
    },
    created() {
        this.loadScorecard()
    },
    methods: {
        loadScorecard() {
            if (this.propData?.scorecard) {
                this.scorecards = [this.propData.scorecard]
            }
        },
        onScorecardSelected(scorecard: iScorecard) {
            this.scorecards[0] = scorecard
            this.$emit('scorecardChanged', this.scorecards[0])
            this.addScorecardVisible = false
        },
        deleteScorecardConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.scorecards = []
                    this.$emit('scorecardChanged', null)
                }
            })
        },
        getFormattedDate(date: any) {
            return formatDate(date)
        }
    }
})
